import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import { EntregasRealizarContext } from 'contexts/EntregasRealizarContext';
import { toastWarning } from 'utils/toast';
import { useModal } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import TipoModal from './Modals/TipoModal';
import Filter from './filter';
import mock from './mock';

const Realizar = () => {
  const rotina = 'EntregasRealizar';
  const titulo = 'Entregas de Vendas a Realizar';
  const navigate = useNavigate();
  const { openModal, closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { exportPdf, exportXls } = useContext(GridContext);
  const {
    postNota,
    getLoading,
    postLoading,
    entregasRealizar,
    getEntregasRealizar,
  } = useContext(EntregasRealizarContext);
  const { control, getValues, reset } = useForm({
    defaultValues: entregasRealizar?.filter,
  });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getEntregasRealizar({ ...props, rotina, filter: getValues() });
    closeModal();
  };

  const options = [
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({
          rotina,
          filter: getValues(),
          order: entregasRealizar?.order,
        }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({
          rotina,
          filter: getValues(),
          order: entregasRealizar?.order,
        }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={entregasRealizar?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
    {
      name: 'Gerar Nota Fiscal',
      icon: 'post_add',
      action: (selected) => {
        const notas = selected?.filter((f) =>
          Boolean(f?.situacao !== 'ENCERRADO')
        );
        if (!Boolean(notas?.length)) {
          return toastWarning('Selecione apenas documentos não encerrados');
        } else {
          const onSubmit = (values) => {
            const data = { ...values, documentos: selected?.map((m) => m?.id) };

            postNota({ data, cb: loadGrid });
          };

          openModal(<TipoModal onSubmit={onSubmit} />);
        }
      },
    },
  ];

  const rowOptions = [
    {
      name: 'Detalhes',
      icon: 'visibility',
      action: ({ row }) => navigate(`/app/Documento/${row?.id}`),
    },
  ];

  return (
    <Container>
      <Header
        rotina={rotina}
        titulo={titulo}
        colunas={entregasRealizar?.colunas}
      />
      <Card>
        <Grid
          grid={entregasRealizar}
          mock={mock}
          options={options}
          rowOptions={rowOptions}
          control={control}
          checkboxSelection
          loading={getLoading || postLoading}
          loadGrid={loadGrid}
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter grid={entregasRealizar} control={control} drops={drops} />
          }
        />
      </Card>
    </Container>
  );
};

export default Realizar;
